import { supabase } from "../supabaseClient";
import { useState } from "react";
import { Mail } from "lucide-react";
import { addNotification } from "../admin/notificationsStore";
import { useTranslation } from "react-i18next";

export default function NewsletterSubscribe() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    const { error } = await supabase.from("subscriptions").insert([{ email }]);
    addNotification(`Nouvel abonné newsletter : ${email}`);

    if (error) {
      setMessage(t("newsletter.alreadySubscribed"));
    } else {
      setMessage(t("newsletter.success"));
      setEmail("");
    }
  }
  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col sm:flex-row gap-2"
        method="POST"
      >
        <div className="relative flex-grow">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-black" />
          <input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.emailPlaceholder")}
            className="w-full h-12 pl-10 pr-4 bg-white border text-black"
          />
        </div>

        <button
          type="submit"
          className="bg-gold hover:bg-gold/90 text-black italic font-bold h-12 px-6 rounded-md "
        >
          {t("newsletter.subscribe")}
        </button>
      </form>

      {message && (
        <p className="text-sm mt-2 text-white font-heading">{message}</p>
      )}
    </>
  );
}
